import VolkswagenImageImporter from './VolkswagenImageImporter'
import SkodaImageImporter from './SkodaImageImporter'
import CupraImageImporter from './CupraImageImporter'
import SeatImageImporter from './SeatImageImporter'

export default class ImageImporter {
  static factory(make) {
    switch (make) {
      case 'VW':
      case 'Volkswagen':
        return new VolkswagenImageImporter()

      case 'Skoda':
        return new SkodaImageImporter()

      case 'Cupra':
      case 'CUPRA':
        return new CupraImageImporter()

      case 'Seat':
        return new SeatImageImporter()

      default:
        throw new Error(`Unsupported make ${make}`)
    }
  }
}
